// extracted by mini-css-extract-plugin
export var content = "_mc-1";
export var divider = "_mc-0";